$('.open-modal').click(function(e) {
    e.preventDefault();

    $(this).modal({
        fadeDuration: 250
    });    
    return false;
});